module.exports = __webpack_public_path__ + "static/profil-321_optimized-360bf86f2ad1fb9266afe4cc654cddd9.jpg";